module.exports = __webpack_public_path__ + "img/banner.8f70f17b.svg";